import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';
import Select from 'react-select'

// reactstrap components
import { Button, Row, Col, FormGroup, Input } from "reactstrap";

// style
import "assets/css/loading.css";

// services
import { showMessage, showQuestion } from "services/message.js";
import { api_POST, api_GET } from "services/api_service.js";
import { getSessionCookie } from "services/session.js";
import { formateDateApi } from "helpers/formats";
import { getSetupAmibiente } from "services/setupGeral_service.js";

export default function AcoesGestor({ requerimento, setshowLoading, handleReturn }) {
    let session = getSessionCookie();

    const { register, handleSubmit, errors, setError, setValue, clearErrors, reset, getValues } = useForm({ mode: "onBlur" });

    const [setup, set_setup] = React.useState(null);

    const [registro, set_registro] = React.useState(null);

    useEffect(() => {
        loadSetup();
        set_registro(requerimento);
        if (requerimento?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Enquadramento" || requerimento?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Análise")
            loadOptionsEnquadramento();
    }, []);


    const loadSetup = () => {
        getSetupAmibiente(function (retorno) {
            if (retorno) {
                set_setup(retorno.data);
            }
        });
    }

    // Enquadramento
    const [options_enquadramento, set_options_enquadramento] = React.useState([]);
    const [enquadramento, set_enquadramento] = React.useState(null);
    const loadOptionsEnquadramento = () => {
        api_GET('enquadramento').then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_enquadramento(result.data);
            }
        });
    }
    const handleEnquadramento = (value) => {
        set_enquadramento(value);
        setValue("enquadramento", value, true);
        clearErrors("enquadramento");
    }

    const handleAguardandoAnalise = (aprovacao) => {
        if ((registro.setupSolicitacaoAcao.acao == "Novo Cadastro" || registro.setupSolicitacaoAcao.acao == "Renovação")
            && enquadramento == null && registro.setupSolicitacaoAcao.enquadramentoObrigatorio) {
            showMessage("Aviso", "Selecione o Enquadramento", 'error', null);
            return;
        }
        
        let data = getValues();
        let json_submit = {
            requerimentoAnaliseGestor_Id: 0,
            requerimento_Id: registro.requerimento_Id,
            dataAnalise: formateDateApi(new Date()),
            usuarioAnalise_Id: session.usuario_Id,
            enquadramento_Id: enquadramento != null ? enquadramento.enquadramento_Id : null,
            aceite: aprovacao,
            observacao: data.observacao,
            codigoSistemaPrefeitura: data.codigoSistemaPrefeitura
        }

        setshowLoading(true);
        api_POST('AnaliseRequerimento/PostRequerimentoAnaliseGestor', json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });

    }

    const handleAguardandoEnquadramento = () => {
        if ((registro.setupSolicitacaoAcao.acao == "Novo Cadastro" || registro.setupSolicitacaoAcao.acao == "Renovação")
            && enquadramento == null && registro.setupSolicitacaoAcao.enquadramentoObrigatorio) {
            showMessage("Aviso", "Selecione o Enquadramento", 'error', null);
            return;
        }

        let data = getValues();
        let json_submit = {
            requerimento_Id: registro.requerimento_Id,
            dataAnalise: formateDateApi(new Date()),
            usuarioAnalise_Id: session.usuario_Id,
            enquadramento_Id: enquadramento != null ? enquadramento.enquadramento_Id : null,
            observacao: data.observacao,
        }

        setshowLoading(true);
        api_POST('AnaliseRequerimento/PostRequerimentoAnaliseEnquadramento', json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });

    }

    const handleAguardandoAprovacao = (aprovacao) => {
        let data = getValues();
        let json_submit = {
            requerimento_Id: registro.requerimento_Id,
            dataAprovacao: formateDateApi(new Date()),
            usuarioAprovacao_Id: session.usuario_Id,
            autorizado: aprovacao,
            observacao: data.observacao,
        }

        setshowLoading(true);
        api_POST('AnaliseRequerimento/PostRequerimentoAprovacao', json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });
    }

    const handleAguardandoCompensacao = () => {
        api_GET('AnaliseRequerimento/AtualizaStatusCobranca/' + registro.requerimento_Id).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                if (result.data) {
                    showMessage("Aviso", "Pagamento Confirmado!", 'success', function () {
                        handleReturn();
                    });
                }
                else {
                    showMessage("Aviso", "O pagamento ainda não foi confirmado!", 'success', null);
                }
            }
        });
    }

    // const handleSolicitacaoVistoria = () => {
    //     api_POST(`AnaliseRequerimento/PostSolicitacaoVistoria/${registro.requerimento_Id}`).then(result => {
    //         if (result.status !== 200) {
    //             showMessage("Aviso", result.message, 'error', null);
    //         }
    //         else {
    //             showMessage("Aviso", "Solicitação de vistoria realizada com sucesso.", 'success', function () {
    //                 handleReturn();
    //             });
    //         }
    //     });
    // }

    const handleAguardandoDiarioOficial = () => {
        let data = getValues();
        if (data.dataPublicacao == "") {
            showMessage("Aviso", "Informe a data de publicação!", 'error', null);
            return;
        }
        let json_submit = {
            requerimento_Id: registro.requerimento_Id,
            usuarioPublicacao_Id: session.usuario_Id,
            dataPublicao: formateDateApi(data.dataPublicacao),
            requerimentoLaudaDiarioOficial_Id: 0
        }

        setshowLoading(true);
        api_POST('AnaliseRequerimento/PostRequerimentoPublicacaoDiarioOficial', json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });
    }

    const handleAguardandoFiscalizacao = (aprovacao) => {
        let data = getValues();
        let json_submit = {
            requerimento_Id: registro.requerimento_Id,
            dataFiscalizacao: formateDateApi(new Date()),
            usuarioFiscalizacao_Id: session.usuario_Id,
            autorizado: aprovacao,
            observacao: data.observacao,
        }

        setshowLoading(true);
        api_POST('AnaliseRequerimento/PostRequerimentoFiscalizacao', json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });
    }

    const handleCancelarRequerimento = () => {
        showQuestion('Atenção', 'Deseja cancelar este requerimento?', 'question', function (result) {
            if (result) {
                let usuario_Id = session != null ? session.usuario_Id : null;
                setshowLoading(true);

                api_POST(`requerimento/PostCancelaRequerimento/${registro.requerimento_Id}/` + usuario_Id).then(result => {
                    setshowLoading(false);
                    if (result.status !== 200)
                        showMessage("Aviso", result.message, 'error', null);
                    else {
                        showMessage("Aviso", "Requerimento cancelado com sucesso!", 'success', function () {
                            handleReturn();
                        });
                    }
                });
            }
        })
    }

    const handleEmitirGuia = () => {
        let json_submit = {
            requerimento_Id: registro.requerimento_Id,
            usuarioEmissao_Id: session.usuario_Id,
        }

        setshowLoading(true);
        api_POST('AnaliseRequerimento/PostRequerimentoCobranca', json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });
    }

    const handleAprovacaoGuia = (aprovacao) => {
        let data = getValues();
        let json_submit = {
            requerimento_Id: registro.requerimento_Id,
            dataAprovacao: formateDateApi(new Date()),
            usuarioAprovacao_Id: session.usuario_Id,
            aprovado: aprovacao,
            observacao: data.observacao,
        }

        setshowLoading(true);
        api_POST('AnaliseRequerimento/PostRequerimentoAprovacaoPagamento', json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });
    }

    const handleEmailCobranca = () => {
        setshowLoading(true);
        api_GET(`AnaliseRequerimento/ReenviarCobrancaEmail/${requerimento.requerimento_Id}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });
    }

    const handleEmailAgendamentoVistoria = () => {
        setshowLoading(true);
        api_GET(`AnaliseRequerimento/ReenviarAgendamentoVistoriaEmail/${requerimento.requerimento_Id}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });
    }

    const handleBaixaManual = () => {
        setshowLoading(true);
        api_POST(`AnaliseRequerimento/BaixaManualBoletoRequerimento/${requerimento.requerimento_Id}/${session.usuario_Id}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                    handleReturn();
                });
            }
        });
    }

    return (
        <>
            {registro != null && (registro.status == "Pendente" || registro.status == "Em Andamento" || registro.status == "Divergente") &&
                registro?.fluxoCadastroEtapaAtual?.tipo != "Aguardando Compensação" &&
                registro?.fluxoCadastroEtapaAtual?.tipo != "Vistoria" &&
                <div>
                    <h3 className="titulo-consulta">Ação</h3>
                    <div className="line-protocolo"></div>
                </div>
            }

            {registro != null && (registro.status == "Pendente" || registro.status == "Em Andamento" || registro.status == "Divergente") &&
                registro?.setupSolicitacaoAcao?.cancelarRequerimentos == true &&
                <Row className="px-2">
                    <Button
                        color="danger"
                        onClick={() => handleCancelarRequerimento()}
                        className="btn-mobile"
                        type="button"
                    >
                        Cancelar Requerimento
                    </Button>
                </Row>
            }

            {registro != null && registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Análise" &&
                <div>
                    {registro.setupSolicitacaoAcao.enquadramentoObrigatorio && 
                        !(registro.setupSolicitacaoAcao.acao == "Cancelamento" && 
                        registro.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla == "RGG" &&
                        registro.setupSolicitacaoAcao.setupSolicitacao.segmento == "Grande Gerador"
                        ) &&
                        <Row className="mt-2">
                            <Col lg="6">
                                <FormGroup>
                                    <b><label><span className="text-danger">*</span> Selecione o Enquadramento</label></b>
                                    <Select
                                        options={options_enquadramento}
                                        name="enquadramento"
                                        getOptionLabel={option => option.descricao}
                                        getOptionValue={option => option.enquadramento_Id}
                                        onChange={(e) => { handleEnquadramento(e) }}
                                        value={enquadramento != null && options_enquadramento.find(obj => obj.enquadramento_Id === enquadramento.enquadramento_Id)}
                                        placeholder="Selecione"
                                        ref={e => register(
                                            { name: "enquadramento" },
                                            { required: true })
                                        }
                                    />
                                    {errors.enquadramento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {(registro.setupSolicitacaoAcao.acao == "Novo Cadastro" || registro.setupSolicitacaoAcao.acao == "Renovação") &&
                        setup && setup.informarCodigoSistemaPrefeitura &&
                        <Row>
                            <Col lg="4">
                                <FormGroup>
                                    <b><label> Código Processo de Credenciamento</label> </b>
                                    <Input
                                        type="text"
                                        name="codigoSistemaPrefeitura"
                                        innerRef={register({ required: true })}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col lg="12">
                            <FormGroup>
                                <b><label> Observação</label> </b>
                                <Input
                                    type="textarea"
                                    name="observacao"
                                    innerRef={register()}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="12">
                            <Button
                                color="success"
                                onClick={() => handleAguardandoAnalise(true)}
                                className="btn-mobile" type="button"
                            >
                                Aprovar
                            </Button>
                            <Button
                                color="danger"
                                onClick={() => handleAguardandoAnalise(false)}
                                className="btn-mobile" type="button"
                            >
                                Reprovar
                            </Button>
                        </Col>
                    </Row>
                </div>
            }

            {registro != null && registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Aprovação" &&
                <div>
                    <Row>
                        <Col lg="12">
                            <FormGroup>
                                <b><label> Observação</label> </b>
                                <Input
                                    type="text"
                                    name="observacao"
                                    innerRef={register()}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="12">
                            <Button
                                color="success"
                                onClick={() => handleAguardandoAprovacao(true)}
                                className="btn-mobile"
                                type="button"
                            >
                                Aprovar
                            </Button>
                            <Button
                                color="danger"
                                onClick={() => handleAguardandoAprovacao(false)}
                                className="btn-mobile"
                                type="button">
                                Reprovar
                            </Button>
                        </Col>
                    </Row>
                </div>
            }

            {/* Solicitar Fiscalização */}
            {registro != null &&
                registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Compensação" &&
                setup && setup.metodologiaCobranca == "Integração PRODAM" &&
                <div>
                    <Row>
                        <Col lg="12">
                            <Button
                                color="info"
                                onClick={() => handleAguardandoCompensacao()}
                                className="btn-mobile"
                                type="button"
                            >
                                Atualizar Cobranças
                            </Button>
                            <Button
                                color="warning"
                                onClick={() => handleBaixaManual()}
                                className="btn-mobile" type="button"
                            >
                                Confirmar baixa manual
                            </Button>
                        </Col>
                    </Row>
                </div>
            }

            {registro != null &&
                registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Diário Oficial" &&
                <div>
                    <Row>
                        <Col lg="3" md="4" sm="12">
                            <FormGroup>
                                <b><label> Data Publicação</label> </b>
                                <Input
                                    type="date"
                                    name="dataPublicacao"
                                    innerRef={register({ required: true })}
                                />
                                {errors.dataPublicacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="12">
                            <Button
                                color="success"
                                onClick={() => handleAguardandoDiarioOficial()}
                                className="btn-mobile"
                                type="button">
                                Confirmar Publicação
                            </Button>
                        </Col>
                    </Row>
                </div>
            }

            {registro != null &&
                registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Fiscalização" &&
                <div>
                    <Row>
                        <Col lg="12">
                            <FormGroup>
                                <b><label> Observação</label> </b>
                                <Input
                                    type="textArea"
                                    name="observacao"
                                    innerRef={register()}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="12">
                            <Button
                                color="success"
                                onClick={() => handleAguardandoFiscalizacao(true)}
                                className="btn-mobile"
                                type="button"
                            >
                                Aprovar
                            </Button>
                            <Button
                                color="danger"
                                onClick={() => handleAguardandoFiscalizacao(false)}
                                className="btn-mobile"
                                type="button"
                            >
                                Reprovar
                            </Button>
                        </Col>
                    </Row>
                </div>
            }

            {registro != null &&
                registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Emissão de Guia" &&
                setup && setup.metodologiaCobranca == "Integração PRODAM" &&
                <div>
                    <Row>
                        <Col lg="12">
                            {registro.requerimentoCobrancas.length > 0 &&
                                <Button
                                    color="info"
                                    onClick={() => handleAguardandoCompensacao()}
                                    className="btn-mobile"
                                    type="button"
                                >
                                    Atualizar Cobranças
                                </Button>
                            }
                            <Button
                                color="warning"
                                onClick={() => handleBaixaManual()}
                                className="btn-mobile"
                                type="button"
                            >
                                Confirmar baixa manual
                            </Button>
                            <Button
                                color="secondary"
                                onClick={() => handleEmitirGuia()}
                                className="btn-mobile"
                                type="button"
                            >
                                Emitir Guia
                            </Button>
                        </Col>
                    </Row>
                </div>
            }
            {registro != null &&
                registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Aprovação de Guia" &&
                <div>
                    <Row>
                        <Col lg="12">
                            <FormGroup>
                                <b><label> Observação</label> </b>
                                <Input
                                    type="textArea"
                                    name="observacao"
                                    innerRef={register()}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="12">
                            <Button
                                color="success"
                                onClick={() => handleAprovacaoGuia(true)}
                                className="btn-mobile"
                                type="button"
                            > Aprovar</Button>
                            <Button
                                color="danger"
                                onClick={() => handleAprovacaoGuia(false)}
                                className="btn-mobile"
                                type="button"
                            >
                                Reprovar
                            </Button>
                        </Col>
                    </Row>
                </div>
            }

            {registro != null &&
                registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Compensação" &&
                <div>
                    <Row>
                        <Col lg="12">
                            <Button
                                color="secondary"
                                onClick={() => handleEmailCobranca()}
                                className="btn-mobile"
                                type="button">
                                Reenviar Email de Cobrança
                            </Button>
                        </Col>
                    </Row>
                </div>
            }

            {registro != null &&
                registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Vistoria" &&
                <div>
                    <Row>
                        <Col lg="12">
                            <Button
                                color="warning"
                                onClick={() => handleEmailAgendamentoVistoria()}
                                className="btn-mobile"
                                type="button"
                            >
                                Reenviar Email de Agendamento
                            </Button>
                        </Col>
                    </Row>
                </div>
            }

            {registro != null &&
                registro.status == "Pendente" &&
                registro?.fluxoCadastroEtapaAtual != null &&
                registro?.fluxoCadastroEtapaAtual?.tipo == "Aguardando Enquadramento" &&
                <div>
                    {registro.setupSolicitacaoAcao.enquadramentoObrigatorio &&
                        <Row className="mt-2">
                            <Col lg="6">
                                <FormGroup>
                                    <b><label><span className="text-danger">*</span> Selecione o Enquadramento</label></b>
                                    <Select
                                        options={options_enquadramento}
                                        name="enquadramento"
                                        getOptionLabel={option => option.descricao}
                                        getOptionValue={option => option.enquadramento_Id}
                                        onChange={(e) => { handleEnquadramento(e) }}
                                        value={enquadramento != null && options_enquadramento.find(obj => obj.enquadramento_Id === enquadramento.enquadramento_Id)}
                                        placeholder="Selecione"
                                        ref={e => register(
                                            { name: "enquadramento" },
                                            { required: true })
                                        }
                                    />
                                    {errors.enquadramento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col lg="12">
                            <FormGroup>
                                <b><label> Observação</label> </b>
                                <Input
                                    type="textarea"
                                    name="observacao"
                                    innerRef={register()}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="12">
                            <Button
                                color="success"
                                onClick={() => handleAguardandoEnquadramento()}
                                className="btn-mobile"
                                type="button"
                            >
                                Confirmar
                            </Button>
                        </Col>
                    </Row>
                </div>
            }
        </>
    );
}           